<template>
  <g fill="none" fill-rule="evenodd">
    <path d="M0 0h24v24H0z" />
    <path
      d="M1.68 10.5l6.84-6a2 2 0 012.64 3L8.3 10H21a2 2 0 110 4H8.31l2.85 2.5a2 2 0 01-2.64 3l-6.84-6a2 2 0 010-3"
      fill="#067BF0"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BackArrowIcon",
});
</script>
